import React from 'react';
import IconComponent from "../../reusable/simpleComponents/IconComponent";
import useSetTimelineValues from "../../../hooks/useSettimelineValues";



const TimelineZoomComponent = () => {
    const { zoomInHandler, zoomOutHandler } = useSetTimelineValues();

    return (
        <div className='zoom-ruler-ui'>
            <IconComponent handler={zoomInHandler}
                           classValue={'zoomIn-ruler icon'}
                           clickedClassValue={' active'}
                           title={'Zoom In Timeline'}
            />
            <IconComponent handler={zoomOutHandler}
                           classValue={'zoomOut-ruler icon'}
                           clickedClassValue={' active'}
                           title={'Zoom Out Timeline'}
            />
        </div>
        )
}

export default TimelineZoomComponent